// ViewPayroll.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../url";
import "../Styling/viewPayroll.css"; // keep your CSS import
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ConfirmModal({
  isOpen,
  title = "Confirm",
  message = "Are you sure?",
  confirmLabel = "Yes confirm",
  cancelLabel = "No",
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
      <div className="confirm-modal">
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>

        <div className="confirm-modal-actions">
          <button
            className="confirm-btn cancel"
            onClick={onCancel}
            type="button"
            disabled={loading}
          >
            {cancelLabel}
          </button>

          <button
            className="confirm-btn confirm"
            onClick={onConfirm}
            type="button"
            disabled={loading}
          >
            {loading ? "Processing..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ViewPayrollNew() {
  const [transferModes, setTransferModes] = useState({});

  const { id } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [orgId, setOrgId] = useState("");
  const [compCode, setCompCode] = useState("");
  const [yearVal, setYearVal] = useState("");
  const [monthName, setMonthName] = useState("");

  // modal & posting states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [posting, setPosting] = useState(false);

  const monthMap = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December",
  };

  useEffect(() => {
    if (!id) return;

    const organisationId = id.substring(0, 4);
    const companyCode = id.substring(4, 8);
    const year = id.substring(8, 12);
    const month = id.substring(12, 14);

    // Save values into state
    setOrgId(organisationId);
    setCompCode(companyCode);
    setYearVal(year);
    setMonthName(monthMap[month] || "Invalid");

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const resp = await axios.get(
          `${Base_URL}/SalaryProcess/GetPayrollData/id?id=${id}`
        );
        setRows(resp.data || []);
        const initialModes = {};
(resp.data || []).forEach((item) => {
  const resourceId = item.payroll?.resourceid;
  if (resourceId) {
    initialModes[resourceId] = "Bank"; // default
  }
});
setTransferModes(initialModes);

      } catch (err) {
        console.error("Failed to fetch payroll data:", err);
        setError(err.response?.data || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);
  const handleTransferModeChange = (resourceId, value) => {
  setTransferModes((prev) => ({
    ...prev,
    [resourceId]: value,
  }));
};

  const toNum = (v) => {
    if (v === null || v === undefined) return 0;
    const n = Number(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

 const summary = rows.reduce(
    (acc, item) => {
      const p = item.payroll || {};
      const s = item.salary || {};

      acc.sumNetPayable += toNum(p.net)||toNum(p.proRatedSalary);
      acc.sumBase += toNum(p.baseInHand);
      acc.sumHra += toNum(p.hra);
      acc.sumOther += toNum(p.otherAllowance);
      acc.sumDeductions += toNum(p.totalDeductions);
      acc.sumCalcBasic += toNum(p.basicPlusDa); // ✅ FIX ADDED

      acc.sumOrigBasic += toNum(s.basicPlusDa);
      acc.sumOrigHra += toNum(s.hra);
      acc.sumOrigSpl += toNum(s.splAll ?? s.other);

      acc.sumGross += toNum(p.baseInHand) 
  acc.sumMa+=toNum(s.ma)
      acc.sumTa+=toNum(s.ta)
      acc.sumCalMA+=toNum(p.ma)
      acc.sumCalTA+=toNum(p.ta)
      acc.gross+=toNum(p.gross)
      return acc;
    },
    {
      sumNetPayable: 0,
      sumBase: 0,
      sumHra: 0,
      sumOther: 0,
      sumDeductions: 0,
      sumGross: 0,

      sumCalcBasic: 0, // ✅ INITIALIZE
      sumOrigBasic: 0,
      sumOrigHra: 0,
      sumOrigSpl: 0,
      sumTa:0,
      sumMa:0,
      sumCalTA:0,
      sumCalMA:0,
      gross:0
    }
  );

  const fmtCurrency = (n) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);

  // Build payload & post
 const handleSendNetPayables = async () => {
  setPosting(true);
  try {
    const items = rows
      .filter((item) => {
        const rid = item.payroll?.resourceid;
        return transferModes[rid] === "Bank"; // ✅ ONLY BANK
      })
      .map((item) => {
        const p = item.payroll || {};
        return {
          resourceId: p.resourceid,
          payrollId: p.payrollId ?? null,
          netPayable: toNum(p.net),
          transferMode: "Bank", // optional, useful for backend
        };
      });

    if (items.length === 0) {
      toast.error("No employees selected for bank transfer");
      setPosting(false);
      return;
    }

    const payload = {
      runId: id,
      items,
    };

    console.log("Final Payroll Payload:", payload);

    const res = await axios.post(
      `${Base_URL}/SalaryProcess/PostPayroll`,
      payload
    );

    toast.success("Payroll executed successfully");
    setShowConfirmModal(false);
    navigate("/hr-dashboard");
  } catch (err) {
    console.error("Error posting payroll:", err);
    toast.error(err.response?.data || err.message);
  } finally {
    setPosting(false);
  }
};


  // Confirm button handler: call the sender
  const onConfirmExecute = async () => {
    await handleSendNetPayables();
  };

  if (loading) {
    return (
      <div>
        <h2>View Payroll</h2>
        <p>Loading payroll data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h2>View Payroll</h2>
        <div style={{ color: "red" }}>Error: {String(error)}</div>
      </div>
    );
  }
const handleDownloadExcel = () => {
  if (!rows || rows.length === 0) {
    toast.error("No payroll data to download");
    return;
  }

  let totals = {
    // ORIGINAL
    "Basic Salary (including Dearness Allowance)": 0,
    "House Rent Allowance (HRA)": 0,
    "Medical Allowance": 0,
    "Conveyance / Transport Allowance": 0,
    "Special Allowance": 0,
    "Child Education Allowance": 0,
    "Advance Statutory Bonus": 0,
    "Gross Salary (Fixed / Monthly Gross)": 0,
    "Provident Fund Contribution": 0,
    "ESIC Contribution": 0,

    // DAYS
    "Total Days in Pay Period": 0,
    "Paid Days / Days Worked": 0,

    // EARNED
    "Earned Basic Salary": 0,
    "Earned HRA": 0,
    "Earned Medical Allowance": 0,
    "Earned Conveyance / Transport Allowance": 0,
    "Earned Special Allowance": 0,
    "Earned Child Education Allowance": 0,
    "Earned Advance Statutory Bonus": 0,
    "Earned Gross": 0,

    // DEDUCTIONS
    "Employee PF Contribution": 0,
    "Employee ESIC Contribution": 0,
    "Total Payroll Deductions": 0,

    // NET
    "Net Salary": 0,
  };

  const excelData = rows.map((item) => {
    const p = item.payroll || {};
    const s = item.salary || {};

    const origSpl = s.splAll ?? s.other ?? 0;

    const originalGross =
      toNum(s.basicPlusDa) +
      toNum(s.hra) +
      toNum(s.ma) +
      toNum(s.ta) +
      toNum(origSpl) +
      toNum(s.childEducationAllowance) +
      toNum(s.advanceStatutoryBonus);

    const row = {
      "Employee Name": item.resource,
      "Employee ID": p.resourceid,

      // ORIGINAL
      "Basic Salary (including Dearness Allowance)": toNum(
        s.basicPlusDa
      ),
      "House Rent Allowance (HRA)": toNum(s.hra),
      "Medical Allowance": toNum(s.ma),
      "Conveyance / Transport Allowance": toNum(s.ta),
      "Special Allowance": toNum(origSpl),
      "Child Education Allowance": toNum(
        s.childEducationAllowance
      ),
      "Advance Statutory Bonus": toNum(
        s.advanceStatutoryBonus
      ),
      "Gross Salary (Fixed / Monthly Gross)": toNum(originalGross),
      "Provident Fund Contribution": toNum(s.pfEmployee),
      "ESIC Contribution": toNum(s.esicEmployee),

      // DAYS
      "Total Days in Pay Period": toNum(p.calendarDays),
      "Paid Days / Days Worked": toNum(p.salaryDays),

      // EARNED
      "Earned Basic Salary": toNum(p.basicPlusDa),
      "Earned HRA": toNum(p.hra),
      "Earned Medical Allowance": toNum(p.ma),
      "Earned Conveyance / Transport Allowance": toNum(p.ta),
      "Earned Special Allowance": toNum(p.otherAllowance),
      "Earned Child Education Allowance": toNum(
        p.childAllowance
      ),
      "Earned Advance Statutory Bonus": toNum(
        p.statutoryAllowance
      ),
      "Earned Gross": toNum(p.proRatedSalary),

      // DEDUCTIONS
      "Employee PF Contribution": toNum(p.pf12Percent),
      "Employee ESIC Contribution": toNum(p.esic075Percent),
      "Total Payroll Deductions": toNum(
        p.totalDeductions
      ),

      // NET
      "Net Salary":
        toNum(p.net) || toNum(p.proRatedSalary),

      // TRANSFER
      "Transfer Mode":
        transferModes[p.resourceid] || "Bank",
    };

    // totals
    Object.keys(totals).forEach((key) => {
      totals[key] += toNum(row[key]);
    });

    return row;
  });

  // TOTAL ROW
  const totalsRow = {
    "Employee Name": "TOTAL",
    "Employee ID": "",

    ...totals,

    "Transfer Mode": "",
  };

  excelData.push(totalsRow);

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Auto column widths
  const columnWidths = Object.keys(excelData[0]).map((key) => ({
    wch: Math.max(key.length + 5, 20),
  }));

  worksheet["!cols"] = columnWidths;

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Payroll"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    blob,
    `Payroll_${orgId}_${compCode}_${monthName}_${yearVal}.xlsx`
  );
};
  return (
    <div className=" payroll-container">
      {/* Heading */}
      <h2 className="text-2xl font-semibold">Payroll For</h2>
      <div className="mb-4 text-gray-700">
        <p>
          <b>Organisation ID:</b> {orgId}
        </p>
        <p>
          <b>Company Code:</b> {compCode}
        </p>
        <p>
          <b>Year:</b> {yearVal}
        </p>
        <p>
          <b>Month:</b> {monthName}
        </p>
      </div>

     <div className="flex items-center justify-between mb-4 gap-3">
  <button
    onClick={() => setShowConfirmModal(true)}
    disabled={loading || rows.length === 0}
    className={`px-4 py-2 rounded shadow ${
      loading || rows.length === 0
        ? "opacity-50 cursor-not-allowed"
        : "hover:opacity-90"
    }`}
  >
    Execute Payroll
  </button>

  <button
    onClick={handleDownloadExcel}
    disabled={rows.length === 0}
    className={`px-4 py-2 rounded shadow bg-green-600  ${
      rows.length === 0
        ? "opacity-50 cursor-not-allowed"
        : "hover:bg-green-700"
    }`}
  >
    Download Excel
  </button>
</div>


      {/* Summary (card boxes) - uses external CSS */}
      <div className="summary-container">
        <div className="summary-card">
          <div className="summary-label">Total Net Salary</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumNetPayable)}</div>
        </div>

        {/* Now shows Total Gross (from payroll.gross or fallback) */}
        <div className="summary-card">
          <div className="summary-label">Total Gross</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumGross)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total House Rent Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total Special Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOther)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total Deductions</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumDeductions)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Original Basic Salary (including Dearness Allowance)</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigBasic)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Original House Rent Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Original Special Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigSpl)}</div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="min-w-full divide-y">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Employee Name</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Employee ID</th>

              {/* ORIGINAL SALARY */}
            <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Basic Salary (including Dearness Allowance)</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>House Rent Allowance (HRA)</th>
             
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Medical Allowance</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Conveyance / Transport Allowance</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Special Allowance</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Child Education Allowance</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Advance Statutory Bonus</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Gross Salary (Fixed / Monthly Gross)</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Provident Fund Contribution</th>
                <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>ESIC Contribution</th>

              {/* CALCULATED PAYROLL AFTER */}
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Total Days in Pay Period</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Paid Days / Days Worked</th>

               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Basic Salary (including Dearness Allowance)</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned House Rent Allowance(HRA)</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Medical Allowance</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Conveyance / Transport Allowance</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Special Allowance</th>
                  <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Child Education Allowance</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Advance Statutory Bonus</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Earned Gross</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Employee PF Contribution</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Employee ESIC Contribution</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Total Payroll Deductions</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>Net Salary</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700" style={{ whiteSpace: "nowrap" }}>
  Bank Transfer
</th>

            </tr>
          </thead>

          <tbody className="divide-y">
            {rows.map((item, idx) => {
              const p = item.payroll || {};
              const s = item.salary || {};
              const origSpl = s.splAll ?? s.other ?? 0;

              return (
                <tr key={p.payrollId ?? idx}>
                  <td className="px-2 py-2 text-sm" style={{ whiteSpace: "nowrap" }}>{item.resource}</td>
                  <td className="px-2 py-2 text-sm" >{p.resourceid}</td>

                  {/* ORIGINAL SALARY */}
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.hra))}</td>
                
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.ta))}</td>
                    <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(origSpl))}</td>
                    <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.childEducationAllowance))}</td>
                    <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.advanceStatutoryBonus))}</td>

                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.basicPlusDa+s.hra+s.ma+s.ta+origSpl))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.pfEmployee))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(s.esicEmployee))}</td>
                
                  {/* CALCULATED */}
                 <td className="px-2 py-2 text-sm">{p.calendarDays ?? "-"}</td>
                  <td className="px-2 py-2 text-sm">{p.salaryDays ?? "-"}</td>

                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.hra))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.ta))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.otherAllowance))}</td>
                   <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.childAllowance))}</td>
                    <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.statutoryAllowance))}</td>
                <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.proRatedSalary))}</td>
               <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.pf12Percent))}</td>
               <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.esic075Percent))}</td>
                  <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.totalDeductions))}</td>
                   <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(toNum(p.net) || toNum(p.proRatedSalary) )}</td>
                   <td className="px-3 py-3 text-sm">
  <select
    value={transferModes[p.resourceid] || "Bank"}
    onChange={(e) =>
      handleTransferModeChange(p.resourceid, e.target.value)
    }
    className="border rounded px-2 py-1 appearance-none"
     style={{
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    paddingRight: "20px" // optional: adjust spacing after removing arrow
  }}
  >
    <option value="Bank">Bank</option>
    <option value="Hold">Hold</option>
  </select>
</td>

                </tr>
              );
            })}
          </tbody>

          <tfoot className="bg-gray-50">
            <tr>
              <td className="px-2 py-2 text-sm font-medium">Totals</td>
              <td />

              {/* Original */}
       <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumOrigBasic)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumOrigHra)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumOrigSpl)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumMa)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumTa)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.gross)}</td>

              <td />
              <td />
              <td/>
              <td/>
              <td/>
              <td/>
              <td/>
              <td/>
              {/* Calculated */}
           <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumCalcBasic)}</td> {/* ✅ FIX */}
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumHra)}</td>
                <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumCalMA)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumCalTA)}</td>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumOther)}</td>
           <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumGross)}</td>
            <td/>
            <td/>
              <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumDeductions)}</td>
              
                <td className="px-3 py-3 text-sm text-left" style={{ whiteSpace: "nowrap" }}>₹ {fmtCurrency(summary.sumNetPayable)||fmtCurrency(summary.sumGross)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={showConfirmModal}
        title="Post Payroll"
        message="Are you sure you want to post?"
        confirmLabel="Yes confirm"
        cancelLabel="No"
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={onConfirmExecute}
        loading={posting}
      />
    </div>
  );
}
